import React, { useContext } from 'react';
import classnames from 'classnames';
import AppContext from '../../../contexts/AppContext';
import { useOffline } from '../../../contexts/OfflineContext';
import { INotification } from '../../../hooks/useNotificationNavigate';

export interface INotificationListProps {
  notifications: INotification[];
  onSelect: (notification: INotification) => void;
  /** `compact` is the popper, `expanded` is the modal */
  variant?: 'compact' | 'expanded';
  emptyMessage?: string;
}

/**
 * The notification rows, shared by the popper and the expanded modal so the two
 * cannot drift apart.
 */
const NotificationList: React.FC<INotificationListProps> = ({
  notifications,
  onSelect,
  variant = 'compact',
  emptyMessage = 'No notifications',
}) => {
  const appContext = useContext(AppContext);
  const isOffline = useOffline();

  const user = appContext.get('user');

  /** Only worth the space when the user actually has more than one tenant */
  const showTenantName = !!user && !!user.tenants && user.tenants.length > 1;

  const offlineStyle = isOffline
    ? { opacity: 0.6, cursor: 'not-allowed' }
    : undefined;

  if (!notifications.length) {
    return <p className='notification-empty'>{emptyMessage}</p>;
  }

  return (
    <ul className={classnames('nav-list', `notification-list-${variant}`)}>
      {notifications.map((notification) => (
        <li
          key={notification.id}
          className={classnames('nav-list-item pointer', {
            isOpened: notification.is_opened,
          })}
          onClick={() => onSelect(notification)}
          style={offlineStyle}
        >
          <div className='notification-row-top'>
            <span className='title'>{notification.title}</span>
            {showTenantName && notification.tenantName && (
              <span className='notification-tenant'>
                {notification.tenantName}
              </span>
            )}
          </div>
          <div className='notification-detail'>
            <span className='notification-content'>{notification.content}</span>
            <span className='notification-date'>{notification.date}</span>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default NotificationList;
